export const AT_COMMENT_SET = 'COMMENT_VALUE_SET';
export const AT_COMMENT_UPDATE = 'COMMENT_EDIT_COMMENT_ID_SET';
export const AT_COMMENT_INIT = 'COMMENT_INIT';
